import { getIdToken } from "src/domains/shared/utils/amplifyCompat";
import { backendBaseUrl } from "src/domains/shared/api/calculation/backendBaseUrl";
import { unwrapEnvelopeRequired } from "src/domains/shared/utils/unwrapEnvelope";
import { DrawingMeshCatalogResponse } from "./drawingMesh.types";

/**
 * main-api는 "Bearer <token>" 형식 필요 — Amplify gateway(Bearer 없는 raw token)와 다르므로
 * API.get 대신 raw fetch + getIdToken() 으로 직접 호출한다 (postMeasure.ts 와 동일 패턴).
 */
export async function getDrawingMeshes(
  projectId: number
): Promise<DrawingMeshCatalogResponse> {
  const token = await getIdToken();

  const res = await fetch(`${backendBaseUrl()}/projects/${projectId}/drawing-meshes`, {
    headers: { Authorization: token },
  });

  if (!res.ok) {
    throw Object.assign(
      new Error(`drawing-meshes 조회 실패 (${res.status})`),
      { status: res.status }
    );
  }

  const body = await res.json();
  // 응답 봉투 { status, data } 를 경계에서 언랩 — 실패는 오류로 승격한다.
  // 이전의 `body.data ?? body` 는 실패 봉투를 그대로 반환해 소비처의 `response.drawings` 가
  // undefined 가 되고, `drawings.map` 에서 TypeError 로 화면이 크래시했다(빈 상태 위장이 아니라
  // 런타임 오류였다). 승격 후에는 전송 실패와 봉투 실패가 하나의 `isError` 로 합쳐진다.
  return unwrapEnvelopeRequired<DrawingMeshCatalogResponse>(
    body,
    "drawing-meshes"
  );
}
